import React from "react";

import { ISafeHTML, isoSafeHTML } from "../models/nominals";

interface IProps {
    html: ISafeHTML;
    inline?: boolean;
    className?: string;
    tagName?: React.HTMLElementType;
}

export const RawHTML = (props: IProps) => {
    const elemProps = {
        className: props.className,
        dangerouslySetInnerHTML: {
            __html: isoSafeHTML.unwrap(props.html),
        },
    };
    let tagName: React.HTMLElementType = "div";
    if (props.inline) {
        tagName = "span";
    }
    if (props.tagName) {
        tagName = props.tagName;
    }
    return React.createElement(tagName, elemProps);
};
